import axios from 'axios';

const baseURL = process.env.REACT_APP_ANALYTICS_URL;
const hostName = process.env.REACT_APP_HOST_NAME;

const analyticsAxiosInstance = axios.create({
	baseURL,
	headers: {
		host_name: hostName,
		'x-host': hostName,
		'sora-api-key': process.env.REACT_APP_ANALYTICS_API_KEY
	}
});

export default analyticsAxiosInstance;
